import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["a", "clickable", "children"],
    _excluded2 = ["style", "children", "className", "startIcon", "endIcon", "size", "outline", "link", "semantic", "disabled", "shape", "onClick", "block", "file", "onChange", "unclickable", "dense", "title", "loading", "square", "href", "target", "data-component-name", "data-event-name"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/no-array-index-key */
import React, { cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isNodeEmpty } from '@jd/jmtd-tools/es/react';
import classNames from '@jd/jmtd-tools/es/classnames';
import { createElement } from '@jd/jmtd-tools/es/element';
import { createPortal } from 'react-dom';
import ConfigConsumer from '../ConfigConsumer';
import TitleTooltip from '../TitleTooltip';
import Loading from '../Loading';

function ButtonKernel(_ref) {
  var a = _ref.a,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return a ? /*#__PURE__*/React.createElement("a", props, children) : clickable ? /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, props), children) : /*#__PURE__*/React.createElement("span", props, children);
}

ButtonKernel.propTypes = {
  a: PropTypes.bool,
  id: PropTypes.string,
  clickable: PropTypes.bool,
  children: PropTypes.node
};
ButtonKernel.defaultProps = {
  a: false,
  id: null,
  clickable: false,
  children: null
};

var Button = /*#__PURE__*/function (_PureComponent) {
  _inherits(Button, _PureComponent);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, props);

    if (props.file) {
      _this.portal = createElement('div.jmtd-button-portal', document.body);
    }

    return _this;
  }

  _createClass(Button, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.portal) {
        document.body.removeChild(this.portal);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          style = _this$props.style,
          children = _this$props.children,
          className = _this$props.className,
          startIcon = _this$props.startIcon,
          endIcon = _this$props.endIcon,
          size = _this$props.size,
          outline = _this$props.outline,
          link = _this$props.link,
          semantic = _this$props.semantic,
          disabled = _this$props.disabled,
          shape = _this$props.shape,
          _onClick = _this$props.onClick,
          block = _this$props.block,
          file = _this$props.file,
          onChange = _this$props.onChange,
          unclickable = _this$props.unclickable,
          dense = _this$props.dense,
          title = _this$props.title,
          loading = _this$props.loading,
          square = _this$props.square,
          href = _this$props.href,
          target = _this$props.target,
          trackComponentName = _this$props['data-component-name'],
          trackEventName = _this$props['data-event-name'],
          others = _objectWithoutProperties(_this$props, _excluded2);

      var anchor = !!href && !disabled; // a标签

      var clickable = !(unclickable || disabled && title);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConfigConsumer, {
        size: size
      }, function (_ref2) {
        var _classNames;

        var configSize = _ref2.size;
        var main = /*#__PURE__*/React.createElement(ButtonKernel, _extends({
          a: anchor,
          href: href,
          target: target,
          "data-component-name": trackComponentName,
          "data-event-name": trackEventName,
          "data-event-content": true
        }, others, {
          clickable: clickable,
          style: style,
          className: classNames('jmtd-button', className, (_classNames = {
            'jmtd-button-disabled': !(clickable || anchor) && disabled,
            'jmtd-button-anchor': anchor,
            'jmtd-button-loading': loading,
            'jmtd-button-large': configSize === 'large',
            'jmtd-button-small': configSize === 'small',
            'jmtd-button-mini': configSize === 'mini',
            'jmtd-button-square': square
          }, _defineProperty(_classNames, "jmtd-button-".concat(shape), !!shape), _defineProperty(_classNames, "jmtd-button-".concat(semantic), !!semantic), _defineProperty(_classNames, 'jmtd-button-outline', outline), _defineProperty(_classNames, 'jmtd-button-block', block), _defineProperty(_classNames, 'jmtd-button-link', link), _defineProperty(_classNames, 'jmtd-button-empty', isNodeEmpty(children)), _defineProperty(_classNames, 'jmtd-button-clickable', clickable), _defineProperty(_classNames, 'jmtd-button-dense', dense), _classNames)),
          disabled: disabled,
          onClick: function onClick(e) {
            if (!disabled) {
              if (file) {
                _this2.inputRef.click();

                _onClick(e);
              } else {
                _onClick(e);
              }
            }
          }
        }), loading && /*#__PURE__*/React.createElement(Loading, {
          className: "jmtd-button-start-icon",
          loading: true,
          size: "mini"
        }), startIcon && !loading && /*#__PURE__*/cloneElement(startIcon, {
          className: classNames(startIcon.props.className, 'jmtd-button-start-icon')
        }), children, endIcon && /*#__PURE__*/cloneElement(endIcon, {
          className: classNames(endIcon.props.className, 'jmtd-button-end-icon')
        }));

        if (title) {
          return /*#__PURE__*/React.createElement(TitleTooltip, {
            arrowPointAtCenter: true,
            title: title,
            placement: "bottom",
            theme: "light"
          }, main);
        }

        return main;
      }), file && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("input", {
        ref: function ref(el) {
          _this2.inputRef = el;
        },
        type: "file",
        onChange: onChange
      }), this.portal));
    }
  }]);

  return Button;
}(PureComponent);

export { Button as default };
Button.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  semantic: PropTypes.oneOf(['default', 'primary', 'info', 'success', 'warning', 'danger', 'help']),
  outline: PropTypes.bool,
  link: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  shape: PropTypes.oneOf(['', 'circle', 'round']),
  onClick: PropTypes.func,
  style: PropTypes.any,
  file: PropTypes.bool,
  onChange: PropTypes.func,
  unclickable: PropTypes.bool,
  dense: PropTypes.bool,
  title: PropTypes.string,
  loading: PropTypes.bool,
  square: PropTypes.bool,
  'data-event-name': PropTypes.string,
  'data-component-name': PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string
};
Button.defaultProps = {
  id: null,
  children: null,
  className: null,
  startIcon: null,
  endIcon: null,
  size: null,
  link: false,
  block: false,
  shape: '',
  semantic: 'default',
  outline: false,
  disabled: false,
  onClick: function onClick() {},
  style: {},
  file: false,
  onChange: function onChange() {},
  unclickable: false,
  dense: false,
  title: null,
  loading: false,
  square: false,
  'data-event-name': 'click',
  'data-component-name': 'Button',
  href: null,
  target: null
};